import { type JwtPayload, jwtDecode } from 'jwt-decode';

export type JwtSubscription = {
  type: 'SUBSCRIPTION' | 'TRIAL';
  subscriptionExpiresAt: string;
};

type RawTempoJwtPayload = {
  sub: string;
  email: string;
  tempo_user_id: string;
  org_id: string;
  tempo_org_id: string;
  tempo_org_name: string;
  connection_name: string;
  subscription?: JwtSubscription;
} & JwtPayload;

type JwtUserContext = {
  email: string;
  auth0UserId: string;
  userId: string;
  auth0OrganizationId: string;
  organizationId: string;
  organizationName: string;
  connectionName: string;
  subscription?: JwtSubscription;
};

export const getJwtUserContext = (token?: string): JwtUserContext => {
  const decoded = jwtDecode<RawTempoJwtPayload>(token ?? '');
  return {
    email: decoded.email,
    auth0UserId: decoded.sub,
    auth0OrganizationId: decoded.org_id,
    userId: decoded.tempo_user_id,
    organizationId: decoded.tempo_org_id,
    organizationName: decoded.tempo_org_name,
    connectionName: decoded.connection_name,
    subscription: decoded.subscription,
  };
};
